export interface EmotionalImpact {
  impact: string
  engagement: string
  risk?: string
}

export function deriveEmotionalImpact(
  valence: number,
  arousal: number,
): EmotionalImpact {
  let impact: string
  let engagement: string
  let risk: string | undefined

  // Determine emotional impact based on valence/arousal quadrants
  if (valence > 60) {
    if (arousal > 60) {
      impact = 'Excited, Positive'
      engagement = 'High'
    } else if (arousal >= 40) {
      impact = 'Pleasant, Moderate'
      engagement = 'Moderate'
    } else {
      impact = 'Calm, Positive'
      engagement = 'Low-Moderate'
      risk = 'May not stop scroll in fast feeds'
    }
  } else if (valence >= 40) {
    if (arousal > 60) {
      impact = 'Alert, Neutral'
      engagement = 'High'
    } else {
      impact = 'Neutral'
      engagement = 'Low'
      risk = 'Neutral response may not drive action'
    }
  } else {
    if (arousal > 60) {
      impact = 'Tense, Negative'
      engagement = 'High'
      risk = 'Negative emotional response may hurt engagement'
    } else {
      impact = 'Sad, Low-energy'
      engagement = 'Low'
      risk = 'Low energy and negative tone - unlikely to convert'
    }
  }

  return { impact, engagement, risk }
}

export function getScoreColor(score: number): string {
  if (score >= 80) return 'text-green-600 dark:text-green-400'
  if (score >= 60) return 'text-yellow-600 dark:text-yellow-400'
  return 'text-red-600 dark:text-red-400'
}

export function getScoreBgColor(score: number): string {
  if (score >= 80) return 'bg-green-100 dark:bg-green-900/30'
  if (score >= 60) return 'bg-yellow-100 dark:bg-yellow-900/30'
  return 'bg-red-100 dark:bg-red-900/30'
}

export function getScoreVerdict(score: number): string {
  if (score >= 80) return 'Run'
  if (score >= 60) return 'Test'
  return "Don't run"
}

export function getLetterGrade(score: number): string {
  if (score >= 90) return 'A'
  if (score >= 80) return 'B+'
  if (score >= 70) return 'B'
  if (score >= 60) return 'C+'
  if (score >= 50) return 'C'
  return 'F'
}

export function getConfidenceBadgeVariant(
  confidence: string,
): 'default' | 'secondary' | 'outline' {
  switch (confidence.toLowerCase()) {
    case 'high':
      return 'default'
    case 'medium':
      return 'secondary'
    default:
      return 'outline'
  }
}
